export default "__VITE_ASSET__r3FNZLLd__"